import {texture, json, padNum} from "p3";
import { Emitter } from "pixi-particles";
import definitions from "../../definitions";
import common from "../../common";
import Actor from "./Actor";
import settings from "../../settings";
import GameScene from "../../scenes/GameScene";

export default class ActorCampfire extends Actor {
    constructor() {
        super(definitions.ACTOR_ID.CAMPFIRE);

        this.collisionRadius = 24;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -34;
        
        this._fireMovieClip = null;
        this._fx = null;
        this._campfireTexture = null;

        this.interactable = settings.PHASE > 1;
        this.interactionRadius = 160;
    }

    init() {
        super.init();

        this.signals.interact.add(this._toggleOnOff, this);

        let frames = [];
        for (let i = 0; i < 15; ++i) {
            frames[i] = texture("fx_campfire_" + padNum(i, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "egnite");

        this._setCampfireTexture();

        this.addViewWithTexture(this._campfireTexture);

        this._fireMovieClip = new P3.MovieClip(sequence, "egnite", false);
        this._fireMovieClip.anchor.set(0.5);
        this._fireMovieClip.y -= 75;
        this.addChild(this._fireMovieClip);
        this._fireMovieClip.animationSpeed = 10;
        this._fireMovieClip.gotoAndPlay("egnite", true);

        this._emitFx();
    }

    update() {
        this._fx && this._fx.update(window.dt);
        this._fireMovieClip && this._fireMovieClip.update(window.dt);

        super.update();
    }

    _setCampfireTexture() {
        const activeLocation = GameScene.active.loadedLevel;
        let locationSuffix = activeLocation[0] + activeLocation.substring(activeLocation.indexOf('_') + 1)[0];
        
        if (locationSuffix === "fb") {
            locationSuffix = "bc";
        }

        this._campfireTexture = texture(locationSuffix.concat("_d_campfire_00"));
    }

    _toggleOnOff() {
        this._fx.emit = !this._fx.emit; 

        if (!this._fx.emit) {
            this._fireMovieClip.visible = false;
            this._fireMovieClip.stop();
            P3.audio.playSound("sfx_fire_off_00");
        } else {
            this._fireMovieClip.visible = true;
            this._fireMovieClip.gotoAndPlay("egnite", true);
            P3.audio.playSound("sfx_fire_on_00");
        }
    }

    _emitFx() {
        this._fx = this._createFx();
    }

    _createFx() {
        const emitter = new Emitter(this, [texture("smoke_particle_fx_00"), texture("smoke_particle_fx_01")], json("fx_smoke_particle_smoulder"));
        emitter.autoUpdate = false;
        emitter.updateSpawnPos(0, -50);
        return emitter;
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
    }

    onInteractionRangeEnter() {
        super.onInteractionRangeEnter();
    }

    onInteractionRangeExit() {
        super.onInteractionRangeExit();
    }

    onInteractWith(actor) {
        super.onInteractWith(actor);
    }
}